<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalReceipts",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"20. (a) Is it your practice to give receipts for goods left with you by non-trade customers, for repairs, valuation, sale, or any other purpose and to require surrender of such receipts before goods are retruned to the customer?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0ReceiptKeptBeforeGoodsReturnedId",
					props: {
						suggest: {
							typeIncludes: "receiptKeptBeforeGoodsReturned"
						},
						createOptions: {
							type: "receiptKeptBeforeGoodsReturned",
							dataType: "string"
						}
					}
				},
				{
					label:
						"20. (b) Do you use entrustment / approbation notes in respect of all entrustments?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0EntrustmentOrApprobationNotesUsedId",
					props: {
						suggest: {
							typeIncludes: "entrustmentOrApprobationNotesUsed"
						},
						createOptions: {
							type: "entrustmentOrApprobationNotesUsed",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
